import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { ACTIONS } from '../../../_config'
import { DEFAULT_LANGUAGE, normalizeLanguage } from '../../../i18n'

export function useLanguage() {
    const dispatch = useDispatch()

    const setLanguage = useCallback(
        (lang: string = DEFAULT_LANGUAGE) => {
            dispatch({
                type: ACTIONS.LOADER.LANG,
                payload: normalizeLanguage(lang),
            })
        },
        [dispatch],
    )

    return { setLanguage }
}
